/** The name of the module */
export const name = 'DataLayer';
export var Layout;
(function (Layout) {
    Layout["MobileWeb"] = "Mobile3";
    Layout["WebView"] = "App WebView";
    Layout["Classic"] = "Classic";
    Layout["Redesign"] = "Redesign";
    Layout["Extension"] = "Extension";
})(Layout || (Layout = {}));
/**
 * @deprecated Use DataLayerSynchronous instead
 */
export default class DataLayer {
    // we are explicitly ignoring here because the data layer could be anything
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static get(propertyName) {
        return new Promise((resolve, reject) => {
            if (!Object.prototype.hasOwnProperty.call(window.dataLayer, propertyName)) {
                reject(new Error(`Invalid property name (${propertyName}) specified.`));
            }
            resolve(window.dataLayer[propertyName]);
        });
    }
}
